import React, { useState, useEffect } from "react";
import axios from "axios";
import "./BaaHam_VisitingExpertUser_ArzyabiForm.css";
import SabteAgahi_DropDown from "../../BaaHam_NormalUsers/BaaHam_NormalUsers_SabteAgahi/SabteAgahi_DropDown";
import { styled } from "@mui/system";
import SwitchUnstyled, { switchUnstyledClasses } from "@mui/base/SwitchUnstyled";
import Select from "react-select";
import { useMediaQuery } from "react-responsive";
import image1 from "../../../../pic1.jpg";
import { BiImageAdd } from "react-icons/bi";

const blue = {
    500: "#007FFF",
};

const grey = {
    400: "#BFC7CF",
    500: "#AAB4BE",
    600: "#6F7E8C",
};

const Root = styled("span")(
    ({ theme }) => `
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;

  cursor: pointer;

  &.${switchUnstyledClasses.disabled} {
    opacity: 0.4;
    cursor: not-allowed;
  }

  & .${switchUnstyledClasses.track} {
    background: ${theme.palette.mode === "dark" ? grey[600] : grey[400]};
    border-radius: 10px;
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  & .${switchUnstyledClasses.thumb} {
    display: block;
    width: 13px;
    height: 13px;
    top: 1.5px;
    left: 1.5px;
    border-radius: 16px;
    background-color: #fff;
    position: relative;
    transition: all 200ms ease;
  }

  &.${switchUnstyledClasses.focusVisible} .${switchUnstyledClasses.thumb} {
    background-color: ${grey[500]};
    box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);
  }

  &.${switchUnstyledClasses.checked} {
    .${switchUnstyledClasses.thumb} {
      left: 15px;
      top: 1.5px;
      background-color: #fff;
    }

    .${switchUnstyledClasses.track} {
      background: ${blue[500]};
    }
  }

  & .${switchUnstyledClasses.input} {
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  }
  `
);

function BaaHam_VisitingExpertUser_ArzyabiForm() {
    const [ImageSrcs, setImageSrc] = useState([]);
    const HandlesetImageSrc = (e) => {
        let temp = ImageSrcs;
        temp.push(e);
        setImageSrc(temp);
    };

    const q1380 = useMediaQuery({ query: "(max-width: 1380px)" });
    const q1230 = useMediaQuery({ query: "(max-width: 1230px)" });
    const q920 = useMediaQuery({ query: "(max-width: 920px)" });
    const q775 = useMediaQuery({ query: "(max-width: 775px)" });
    const q715 = useMediaQuery({ query: "(max-width: 715px)" });
    let fontSizeRes = "13px";
    let selectWidth = "275px";
    if (q1380) {
        selectWidth = "245px";
    }

    if (q1230) {
        selectWidth = "200px";
    }
    if (q920) {
        fontSizeRes = "11px";
    }
    if (q775) {
        fontSizeRes = "9.5px";
    }
    if (q715) {
        fontSizeRes = "11px";
    }
    const res500 = useMediaQuery({ query: "(max-width: 500px)" });
    const res600 = useMediaQuery({ query: "(max-width: 600px)" });
    const res700 = useMediaQuery({ query: "(max-width: 700px)" });
    const [AgahiSwitch, setAgahiSwitch] = useState(1);
    let selectHeight = "36px";
    if (res700) {
        selectHeight = "30px";
    }

    const customStyles = {
        control: (base, state) => ({
            ...base,
            /*borderColor: state.isFocused ? "yellow" : "green",
    "&:hover": {
      borderColor: state.isFocused ? "red" : "blue"
    }*/
            minHeight: selectHeight,
            height: selectHeight,
            width: "100%",
            border: "none",
            borderRadius: "10px",
            backgroundColor: "rgb(245, 245, 245)",
            "&:hover": {
                borderColor: "#d1d1d1",
            },
            "&:focus": {
                borderColor: "#d1d1d1",
            },
            "&:active": {
                borderColor: "#d1d1d1",
            },
            display: "flex",
        }),
        option: (provided, state) => ({
            ...provided,
        }),
        indicatorSeparator: (styles) => ({ display: "none" }),
        singleValue: (provided) => ({
            ...provided,
            color: "rgb(98, 98, 98)",
            fontSize: res500 ? "8px" : res600 ? "9px" : res700 ? "10px" : "12px",
            display: "flex",
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            height: selectHeight,
            padding: "0 6px",

            display: "flex",
            fontSize: fontSizeRes,
            color: "rgb(178, 178, 178)",
            fontWeight: "bold",
        }),
        input: (provided, state) => ({
            ...provided,
            margin: "0px",
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: selectHeight,
        }),

        dropdownIndicator: (base) => ({
            ...base,
            fontSize: res600 ? "6px" : "8px",

            "&:hover": {
                color: "#5843b1",
            },
            paddingTop: 2,
            paddingBottom: 2,
        }),
        clearIndicator: (styles) => ({
            ...styles,
            paddingTop: 2,
            paddingBottom: 2,
        }),
        menu: (base) => ({
            ...base,
            // override border radius to match the box
            borderRadius: 0,
            // kill the gap
            marginTop: 0,
        }),
    };

    /* /////////////////////////////////////////////////////////////////// */
    const [locationCodeSelected, setlocationCodeSelected] = React.useState({
        lc1: null,
        lc2: null,
        lc3: null,
        lc4: null,
    });
    const [mahallehData, setMahallehData] = React.useState({
        population: 0,
        area50: 0,
        area75: 0,
        area100: 0,
        area150: 0,
        area200: 0,
        area300: 0,
        area500: 0,
        area500Plus: 0,
        locationArea: 0,
        population4y: 0,
        population9y: 0,
        population14y: 0,
        population19y: 0,
        population39y: 0,
        population59y: 0,
        population60y: 0,
        populationSingle: 0,
        populationMarried: 0,
        populationWifeless: 0,
        homeless: 0,
        crossingBarrier: 0,
        nuisance: 0,
        animalProblems: 0,
        garbageProblems: 0,
        cleaning: 0,
    });
    const [locationCodeData, setLocationCodeData] = React.useState({
        population: 0,
        area50: 0,
        area75: 0,
        area100: 0,
        area150: 0,
        area200: 0,
        area300: 0,
        area500: 0,
        area500Plus: 0,
        locationArea: 0,
        population4y: 0,
        population9y: 0,
        population14y: 0,
        population19y: 0,
        population39y: 0,
        population59y: 0,
        population60y: 0,
        populationSingle: 0,
        populationMarried: 0,
        populationWifeless: 0,
        homeless: 0,
        crossingBarrier: 0,
        nuisance: 0,
        animalProblems: 0,
        garbageProblems: 0,
        cleaning: 0,
    });
    const [locationCodeList, setlocationCodeList] = React.useState([]);
    const [mahallehValue, setMahallehValue] = React.useState(null);

    function mahallehHandleChange(event) {
        console.log(event);
        setMahallehValue(event.value);

        let mahallehName = event.value;
        axios
            .post("https://hammaskan.ir:8443/api/dbase/Mahalleh", {
                mahalleh: mahallehName,
            })
            .then((res) => {
                console.log(res.data.data);
                // console.log(res.data.data[0].state);
                let locationCodes = [];
                let population = 0;
                let area50 = 0;
                let area75 = 0;
                let area100 = 0;
                let area150 = 0;
                let area200 = 0;
                let area300 = 0;
                let area500 = 0;
                let area500Plus = 0;
                let locationArea = 0;
                let population4y = 0;
                let population9y = 0;
                let population14y = 0;
                let population19y = 0;
                let population39y = 0;
                let population59y = 0;
                let population60y = 0;
                let populationSingle = 0;
                let populationMarried = 0;
                let populationWifeless = 0;
                let homeless = 0;
                let crossingBarrier = 0;
                let nuisance = 0;
                let animalProblems = 0;
                let garbageProblems = 0;
                let cleaning = 0;
                // // console.log(states);
                res.data.data.forEach((item, index) => {
                    locationCodes.push({ id: "locationCode", label: item.locationCode, value: item.locationCode });
                    setlocationCodeList(locationCodes);

                    population = population + item.population;
                    area50 = area50 + item.area50;
                    area75 = area75 + item.area75;
                    area100 = area100 + item.area100;
                    area150 = area150 + item.area150;
                    area200 = area200 + item.area200;
                    area300 = area300 + item.area300;
                    area500 = area500 + item.area500;
                    area500Plus = area500Plus + item.area500Plus;
                    if (item.locationArea) {
                        locationArea = locationArea + Number(item.locationArea);
                        console.log(Number(item.locationArea));
                    }

                    population4y = population4y + item.population4y;
                    population9y = population9y + item.population9y;
                    population14y = population14y + item.population14y;
                    population19y = population19y + item.population19y;
                    population39y = population39y + item.population39y;
                    population59y = population59y + item.population59y;
                    population60y = population60y + item.population60y;
                    populationSingle = populationSingle + item.populationSingle;
                    populationMarried = populationMarried + item.populationMarried;
                    populationWifeless = populationWifeless + item.populationWifeless;
                    homeless = homeless + item.homeless;
                    crossingBarrier = crossingBarrier + item.crossingBarrier;
                    nuisance = nuisance + item.nuisance;
                    animalProblems = animalProblems + item.animalProblems;
                    garbageProblems = garbageProblems + item.garbageProblems;
                    cleaning = cleaning + item.cleaning;
                    if (index === res.data.data.length - 1) {
                        setMahallehData({
                            population: population,
                            area50: area50,
                            area75: area75,
                            area100: area100,
                            area150: area150,
                            area200: area200,
                            area300: area300,
                            area500: area500,
                            area500Plus: area500Plus,
                            locationArea: Number(locationArea.toFixed(0)),
                            population4y: population4y,
                            population9y: population9y,
                            population14y: population14y,
                            population19y: population19y,
                            population39y: population39y,
                            population59y: population59y,
                            population60y: population60y,
                            populationSingle: populationSingle,
                            populationMarried: populationMarried,
                            populationWifeless: populationWifeless,
                            homeless: homeless,
                            crossingBarrier: crossingBarrier,
                            nuisance: nuisance,
                            animalProblems: animalProblems,
                            garbageProblems: garbageProblems,
                            cleaning: cleaning,
                        });
                        console.log(mahallehData);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
                // window.location.href = "./Account";
            });
    }
    function locationCode1handleChange(event) {
        axios
            .post("https://hammaskan.ir:8443/api/dbase/locationCodes", {
                locationCodes: [event.value],
            })
            .then((res) => {
                console.log(res.data.data);
                let locationCodes = [];
                let population = 0;
                let area50 = 0;
                let area75 = 0;
                let area100 = 0;
                let area150 = 0;
                let area200 = 0;
                let area300 = 0;
                let area500 = 0;
                let area500Plus = 0;
                let locationArea = 0;
                let population4y = 0;
                let population9y = 0;
                let population14y = 0;
                let population19y = 0;
                let population39y = 0;
                let population59y = 0;
                let population60y = 0;
                let populationSingle = 0;
                let populationMarried = 0;
                let populationWifeless = 0;
                let homeless = 0;
                let crossingBarrier = 0;
                let nuisance = 0;
                let animalProblems = 0;
                let garbageProblems = 0;
                let cleaning = 0;
                res.data.data.forEach((item, index) => {
                    population = locationCodeData.population + item.population;
                    area50 = locationCodeData.area50 + item.area50;
                    area75 = locationCodeData.area75 + item.area75;
                    area100 = locationCodeData.area100 + item.area100;
                    area150 = locationCodeData.area150 + item.area150;
                    area200 = locationCodeData.area200 + item.area200;
                    area300 = locationCodeData.area300 + item.area300;
                    area500 = locationCodeData.area500 + item.area500;
                    area500Plus = locationCodeData.area500Plus + item.area500Plus;
                    if (item.locationArea) {
                        locationArea = locationCodeData.locationArea + Number(item.locationArea);
                        console.log(Number(item.locationArea));
                    }
                    population4y = locationCodeData.population4y + item.population4y;
                    population9y = locationCodeData.population9y + item.population9y;
                    population14y = locationCodeData.population14y + item.population14y;
                    population19y = locationCodeData.population19y + item.population19y;
                    population39y = locationCodeData.population39y + item.population39y;
                    population59y = locationCodeData.population59y + item.population59y;
                    population60y = locationCodeData.population60y + item.population60y;
                    populationSingle = locationCodeData.populationSingle + item.populationSingle;
                    populationMarried = locationCodeData.populationMarried + item.populationMarried;
                    populationWifeless = locationCodeData.populationWifeless + item.populationWifeless;
                    homeless = locationCodeData.homeless + item.homeless;
                    crossingBarrier = locationCodeData.crossingBarrier + item.crossingBarrier;
                    nuisance = locationCodeData.nuisance + item.nuisance;
                    animalProblems = locationCodeData.animalProblems + item.animalProblems;
                    garbageProblems = locationCodeData.garbageProblems + item.garbageProblems;
                    cleaning = locationCodeData.cleaning + item.cleaning;
                    if (index === res.data.data.length - 1) {
                        setLocationCodeData((prev) => ({
                            ...prev,
                            population: population,
                            area50: area50,
                            area75: area75,
                            area100: area100,
                            area150: area150,
                            area200: area200,
                            area300: area300,
                            area500: area500,
                            area500Plus: area500Plus,
                            locationArea: Number(locationArea.toFixed(0)),
                            population4y: population4y,
                            population9y: population9y,
                            population14y: population14y,
                            population19y: population19y,
                            population39y: population39y,
                            population59y: population59y,
                            population60y: population60y,
                            populationSingle: populationSingle,
                            populationMarried: populationMarried,
                            populationWifeless: populationWifeless,
                            homeless: homeless,
                            crossingBarrier: crossingBarrier,
                            nuisance: nuisance,
                            animalProblems: animalProblems,
                            garbageProblems: garbageProblems,
                            cleaning: cleaning,
                        }));
                        console.log(locationCodeData);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
        setlocationCodeSelected((prev) => ({ ...prev, lc1: event.value }));
    }
    function locationCode2handleChange(event) {
        axios
            .post("https://hammaskan.ir:8443/api/dbase/locationCodes", {
                locationCodes: [event.value],
            })
            .then((res) => {
                console.log(res.data.data);
                let locationCodes = [];
                let population = 0;
                let area50 = 0;
                let area75 = 0;
                let area100 = 0;
                let area150 = 0;
                let area200 = 0;
                let area300 = 0;
                let area500 = 0;
                let area500Plus = 0;
                let locationArea = 0;
                let population4y = 0;
                let population9y = 0;
                let population14y = 0;
                let population19y = 0;
                let population39y = 0;
                let population59y = 0;
                let population60y = 0;
                let populationSingle = 0;
                let populationMarried = 0;
                let populationWifeless = 0;
                let homeless = 0;
                let crossingBarrier = 0;
                let nuisance = 0;
                let animalProblems = 0;
                let garbageProblems = 0;
                let cleaning = 0;
                res.data.data.forEach((item, index) => {
                    population = locationCodeData.population + item.population;
                    area50 = locationCodeData.area50 + item.area50;
                    area75 = locationCodeData.area75 + item.area75;
                    area100 = locationCodeData.area100 + item.area100;
                    area150 = locationCodeData.area150 + item.area150;
                    area200 = locationCodeData.area200 + item.area200;
                    area300 = locationCodeData.area300 + item.area300;
                    area500 = locationCodeData.area500 + item.area500;
                    area500Plus = locationCodeData.area500Plus + item.area500Plus;
                    if (item.locationArea) {
                        locationArea = locationCodeData.locationArea + Number(item.locationArea);
                        console.log(Number(item.locationArea));
                    }
                    population4y = locationCodeData.population4y + item.population4y;
                    population9y = locationCodeData.population9y + item.population9y;
                    population14y = locationCodeData.population14y + item.population14y;
                    population19y = locationCodeData.population19y + item.population19y;
                    population39y = locationCodeData.population39y + item.population39y;
                    population59y = locationCodeData.population59y + item.population59y;
                    population60y = locationCodeData.population60y + item.population60y;
                    populationSingle = locationCodeData.populationSingle + item.populationSingle;
                    populationMarried = locationCodeData.populationMarried + item.populationMarried;
                    populationWifeless = locationCodeData.populationWifeless + item.populationWifeless;
                    homeless = locationCodeData.homeless + item.homeless;
                    crossingBarrier = locationCodeData.crossingBarrier + item.crossingBarrier;
                    nuisance = locationCodeData.nuisance + item.nuisance;
                    animalProblems = locationCodeData.animalProblems + item.animalProblems;
                    garbageProblems = locationCodeData.garbageProblems + item.garbageProblems;
                    cleaning = locationCodeData.cleaning + item.cleaning;
                    if (index === res.data.data.length - 1) {
                        setLocationCodeData((prev) => ({
                            ...prev,
                            population: population,
                            area50: area50,
                            area75: area75,
                            area100: area100,
                            area150: area150,
                            area200: area200,
                            area300: area300,
                            area500: area500,
                            area500Plus: area500Plus,
                            locationArea: Number(locationArea.toFixed(0)),
                            population4y: population4y,
                            population9y: population9y,
                            population14y: population14y,
                            population19y: population19y,
                            population39y: population39y,
                            population59y: population59y,
                            population60y: population60y,
                            populationSingle: populationSingle,
                            populationMarried: populationMarried,
                            populationWifeless: populationWifeless,
                            homeless: homeless,
                            crossingBarrier: crossingBarrier,
                            nuisance: nuisance,
                            animalProblems: animalProblems,
                            garbageProblems: garbageProblems,
                            cleaning: cleaning,
                        }));
                        console.log(locationCodeData);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
        setlocationCodeSelected((prev) => ({ ...prev, lc2: event.value }));
    }
    function locationCode3handleChange(event) {
        axios
            .post("https://hammaskan.ir:8443/api/dbase/locationCodes", {
                locationCodes: [event.value],
            })
            .then((res) => {
                console.log(res.data.data);
                let locationCodes = [];
                let population = 0;
                let area50 = 0;
                let area75 = 0;
                let area100 = 0;
                let area150 = 0;
                let area200 = 0;
                let area300 = 0;
                let area500 = 0;
                let area500Plus = 0;
                let locationArea = 0;
                let population4y = 0;
                let population9y = 0;
                let population14y = 0;
                let population19y = 0;
                let population39y = 0;
                let population59y = 0;
                let population60y = 0;
                let populationSingle = 0;
                let populationMarried = 0;
                let populationWifeless = 0;
                let homeless = 0;
                let crossingBarrier = 0;
                let nuisance = 0;
                let animalProblems = 0;
                let garbageProblems = 0;
                let cleaning = 0;
                res.data.data.forEach((item, index) => {
                    population = locationCodeData.population + item.population;
                    area50 = locationCodeData.area50 + item.area50;
                    area75 = locationCodeData.area75 + item.area75;
                    area100 = locationCodeData.area100 + item.area100;
                    area150 = locationCodeData.area150 + item.area150;
                    area200 = locationCodeData.area200 + item.area200;
                    area300 = locationCodeData.area300 + item.area300;
                    area500 = locationCodeData.area500 + item.area500;
                    area500Plus = locationCodeData.area500Plus + item.area500Plus;
                    if (item.locationArea) {
                        locationArea = locationCodeData.locationArea + Number(item.locationArea);
                        console.log(Number(item.locationArea));
                    }
                    population4y = locationCodeData.population4y + item.population4y;
                    population9y = locationCodeData.population9y + item.population9y;
                    population14y = locationCodeData.population14y + item.population14y;
                    population19y = locationCodeData.population19y + item.population19y;
                    population39y = locationCodeData.population39y + item.population39y;
                    population59y = locationCodeData.population59y + item.population59y;
                    population60y = locationCodeData.population60y + item.population60y;
                    populationSingle = locationCodeData.populationSingle + item.populationSingle;
                    populationMarried = locationCodeData.populationMarried + item.populationMarried;
                    populationWifeless = locationCodeData.populationWifeless + item.populationWifeless;
                    homeless = locationCodeData.homeless + item.homeless;
                    crossingBarrier = locationCodeData.crossingBarrier + item.crossingBarrier;
                    nuisance = locationCodeData.nuisance + item.nuisance;
                    animalProblems = locationCodeData.animalProblems + item.animalProblems;
                    garbageProblems = locationCodeData.garbageProblems + item.garbageProblems;
                    cleaning = locationCodeData.cleaning + item.cleaning;
                    if (index === res.data.data.length - 1) {
                        setLocationCodeData((prev) => ({
                            ...prev,
                            population: population,
                            area50: area50,
                            area75: area75,
                            area100: area100,
                            area150: area150,
                            area200: area200,
                            area300: area300,
                            area500: area500,
                            area500Plus: area500Plus,
                            locationArea: Number(locationArea.toFixed(0)),
                            population4y: population4y,
                            population9y: population9y,
                            population14y: population14y,
                            population19y: population19y,
                            population39y: population39y,
                            population59y: population59y,
                            population60y: population60y,
                            populationSingle: populationSingle,
                            populationMarried: populationMarried,
                            populationWifeless: populationWifeless,
                            homeless: homeless,
                            crossingBarrier: crossingBarrier,
                            nuisance: nuisance,
                            animalProblems: animalProblems,
                            garbageProblems: garbageProblems,
                            cleaning: cleaning,
                        }));
                        console.log(locationCodeData);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
        setlocationCodeSelected((prev) => ({ ...prev, lc3: event.value }));
    }
    function locationCode4handleChange(event) {
        axios
            .post("https://hammaskan.ir:8443/api/dbase/locationCodes", {
                locationCodes: [event.value],
            })
            .then((res) => {
                console.log(res.data.data);
                let locationCodes = [];
                let population = 0;
                let area50 = 0;
                let area75 = 0;
                let area100 = 0;
                let area150 = 0;
                let area200 = 0;
                let area300 = 0;
                let area500 = 0;
                let area500Plus = 0;
                let locationArea = 0;
                let population4y = 0;
                let population9y = 0;
                let population14y = 0;
                let population19y = 0;
                let population39y = 0;
                let population59y = 0;
                let population60y = 0;
                let populationSingle = 0;
                let populationMarried = 0;
                let populationWifeless = 0;
                let homeless = 0;
                let crossingBarrier = 0;
                let nuisance = 0;
                let animalProblems = 0;
                let garbageProblems = 0;
                let cleaning = 0;
                res.data.data.forEach((item, index) => {
                    population = locationCodeData.population + item.population;
                    area50 = locationCodeData.area50 + item.area50;
                    area75 = locationCodeData.area75 + item.area75;
                    area100 = locationCodeData.area100 + item.area100;
                    area150 = locationCodeData.area150 + item.area150;
                    area200 = locationCodeData.area200 + item.area200;
                    area300 = locationCodeData.area300 + item.area300;
                    area500 = locationCodeData.area500 + item.area500;
                    area500Plus = locationCodeData.area500Plus + item.area500Plus;
                    if (item.locationArea) {
                        locationArea = locationCodeData.locationArea + Number(item.locationArea);
                        console.log(Number(item.locationArea));
                    }
                    population4y = locationCodeData.population4y + item.population4y;
                    population9y = locationCodeData.population9y + item.population9y;
                    population14y = locationCodeData.population14y + item.population14y;
                    population19y = locationCodeData.population19y + item.population19y;
                    population39y = locationCodeData.population39y + item.population39y;
                    population59y = locationCodeData.population59y + item.population59y;
                    population60y = locationCodeData.population60y + item.population60y;
                    populationSingle = locationCodeData.populationSingle + item.populationSingle;
                    populationMarried = locationCodeData.populationMarried + item.populationMarried;
                    populationWifeless = locationCodeData.populationWifeless + item.populationWifeless;
                    homeless = locationCodeData.homeless + item.homeless;
                    crossingBarrier = locationCodeData.crossingBarrier + item.crossingBarrier;
                    nuisance = locationCodeData.nuisance + item.nuisance;
                    animalProblems = locationCodeData.animalProblems + item.animalProblems;
                    garbageProblems = locationCodeData.garbageProblems + item.garbageProblems;
                    cleaning = locationCodeData.cleaning + item.cleaning;
                    if (index === res.data.data.length - 1) {
                        setLocationCodeData((prev) => ({
                            ...prev,
                            population: population,
                            area50: area50,
                            area75: area75,
                            area100: area100,
                            area150: area150,
                            area200: area200,
                            area300: area300,
                            area500: area500,
                            area500Plus: area500Plus,
                            locationArea: Number(locationArea.toFixed(0)),
                            population4y: population4y,
                            population9y: population9y,
                            population14y: population14y,
                            population19y: population19y,
                            population39y: population39y,
                            population59y: population59y,
                            population60y: population60y,
                            populationSingle: populationSingle,
                            populationMarried: populationMarried,
                            populationWifeless: populationWifeless,
                            homeless: homeless,
                            crossingBarrier: crossingBarrier,
                            nuisance: nuisance,
                            animalProblems: animalProblems,
                            garbageProblems: garbageProblems,
                            cleaning: cleaning,
                        }));
                        console.log(locationCodeData);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
        setlocationCodeSelected((prev) => ({ ...prev, lc4: event.value }));
    }
    {
        /* /////////////////////////////////////////////////////////////////// */
    }
    const [hallData, setHallData] = useState({
        hallMainScore: 0,
        kitchenMainScore: 0,
        bedroomsMainScore: 0,
        iwcMainScore: 0,
        fwcMainScore: 0,
        wallBedroomMainScore: 0,
        expertScore: 0,
    });
    function hallhandleChange(event) {
        // console.log(event);
        var targetId = event.id;
        var targetValue = event.value;
        setHallData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    function hallhandleNumberInputChange(event) {
        // console.log(event.target.valueAsNumber);
        // console.log(event.target.id);
        var targetId = event.target.id;
        var targetValue = event.target.valueAsNumber;
        setHallData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    useEffect(() => {
        console.log(hallData);
    }, [hallData]);

    useEffect(() => {
        var hallMainScore = 0;
        if (hallData.hallDimensionsScore) {
            hallMainScore = hallMainScore + hallData.hallDimensionsScore * 3.5;
        }
        if (hallData.hallDimensionsArea && hallData.buildingArea) {
            var calcArea = (hallData.hallDimensionsArea * 100) / hallData.buildingArea;
            console.log(calcArea);
            if (calcArea < 30) {
                hallMainScore = hallMainScore + 0.8;
            }
            if (calcArea >= 30 && calcArea <= 35) {
                hallMainScore = hallMainScore + 3.5;
            }
            if (calcArea > 35) {
                hallMainScore = hallMainScore + 7;
            }
        }
        if (hallData.ceilingHeightScore) {
            hallMainScore = hallMainScore + hallData.ceilingHeightScore * 3.5;
        }
        if (hallData.hallDimensionsCrookedScore) {
            hallMainScore = hallMainScore + hallData.hallDimensionsCrookedScore * 3.5;
        }
        setHallData((prev) => ({ ...prev, hallMainScore: hallMainScore }));
    }, [hallData.hallDimensionsScore, hallData.hallDimensionsArea, hallData.buildingArea, hallData.ceilingHeightScore, hallData.hallDimensionsCrookedScore]);

    useEffect(() => {
        var kitchenMainScore = 0;
        if (hallData.kitchenArea && hallData.buildingArea) {
            var calcArea = (hallData.kitchenArea * 100) / hallData.buildingArea;
            console.log(calcArea);
            if (calcArea < 7) {
                kitchenMainScore = kitchenMainScore + 0.7;
            }
            if (calcArea >= 7 && calcArea <= 12) {
                kitchenMainScore = kitchenMainScore + 3;
            }
            if (calcArea > 12) {
                kitchenMainScore = kitchenMainScore + 6;
            }
        }
        if (hallData.kitchenUseScore) {
            kitchenMainScore = kitchenMainScore + hallData.kitchenUseScore * 3;
        }

        if (hallData.kitchenProportion) {
            kitchenMainScore = kitchenMainScore + hallData.kitchenProportion * 3;
        }
        if (hallData.kitchenCrookedScore) {
            kitchenMainScore = kitchenMainScore + hallData.kitchenCrookedScore * 3;
        }
        setHallData((prev) => ({ ...prev, kitchenMainScore: kitchenMainScore }));
    }, [hallData.buildingArea, hallData.kitchenArea, hallData.kitchenUseScore, hallData.kitchenProportion, hallData.kitchenCrookedScore]);

    useEffect(() => {
        var bedroomsMainScore = 0;
        if (hallData.bedroomsScore) {
            bedroomsMainScore = bedroomsMainScore + hallData.bedroomsScore * 1.6;
        }

        if (hallData.bedroomsWallClosetScore) {
            bedroomsMainScore = bedroomsMainScore + hallData.bedroomsWallClosetScore * 1.6;
        }
        if (hallData.bedroomsMasterScore) {
            bedroomsMainScore = bedroomsMainScore + hallData.bedroomsMasterScore * 1.6;
        }
        if (hallData.bedroomsAtmosphereScore) {
            bedroomsMainScore = bedroomsMainScore + hallData.bedroomsAtmosphereScore * 1.6;
        }
        if (hallData.bedroomsCrookedScore) {
            bedroomsMainScore = bedroomsMainScore + hallData.bedroomsCrookedScore * 1.6;
        }
        setHallData((prev) => ({ ...prev, bedroomsMainScore: bedroomsMainScore }));
    }, [hallData.bedroomsNumber, hallData.bedroomsScore, hallData.bedroomsWallClosetScore, hallData.bedroomsMasterScore, hallData.bedroomsAtmosphereScore, hallData.bedroomsCrookedScore]);

    useEffect(() => {
        var iwcMainScore = 0;
        if (hallData.iwcSCore) {
            iwcMainScore = iwcMainScore + hallData.iwcSCore * 0.5;
        }
        if (hallData.iwcPlacementScore) {
            iwcMainScore = iwcMainScore + hallData.iwcPlacementScore * 1;
        }
        if (hallData.iwcNearBedroomScore) {
            iwcMainScore = iwcMainScore + hallData.iwcNearBedroomScore * 0.5;
        }
        setHallData((prev) => ({ ...prev, iwcMainScore: iwcMainScore }));
    }, [hallData.iwcSCore, hallData.iwcPlacementScore, hallData.iwcNearBedroomScore]);

    useEffect(() => {
        var fwcMainScore = 0;
        if (hallData.fwcScore) {
            fwcMainScore = fwcMainScore + hallData.fwcScore * 0.5;
        }
        if (hallData.fwcPlacementScore) {
            fwcMainScore = fwcMainScore + hallData.fwcPlacementScore * 1;
        }
        if (hallData.fwcNearBedroomScore) {
            fwcMainScore = fwcMainScore + hallData.fwcNearBedroomScore * 0.5;
        }
        setHallData((prev) => ({ ...prev, fwcMainScore: fwcMainScore }));
    }, [hallData.fwcScore, hallData.fwcPlacementScore, hallData.fwcNearBedroomScore]);

    useEffect(() => {
        var wallBedroomMainScore = 0;
        if (hallData.wallBedroomScore) {
            wallBedroomMainScore = wallBedroomMainScore + hallData.wallBedroomScore * 2;
        }
        setHallData((prev) => ({ ...prev, wallBedroomMainScore: wallBedroomMainScore }));
    }, [hallData.wallBedroomScore]);

    {
        /* /////////////////////////////////////////////////////////////////// */
    }
    const [materialData, setMaterialData] = useState({
        socketMainScore: 0,
        entranceMainScore: 0,
        windowMainScore: 0,
        faucetsMainScore: 0,
        cabinetsMainScore: 0,
        doorPhoneMainScore: 0,
        baseMaterialsMainScore: 0,
        expertScore: 0,
    });
    function materialhandleChange(event) {
        // console.log(event);
        var targetId = event.id;
        var targetValue = event.value;
        setMaterialData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    function materialhandleNumberInputChange(event) {
        // console.log(event.target.valueAsNumber);
        // console.log(event.target.id);
        var targetId = event.target.id;
        var targetValue = event.target.valueAsNumber;
        setMaterialData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    useEffect(() => {
        console.log(materialData);
    }, [materialData]);

    useEffect(() => {
        var socketMainScore = 0;
        if (materialData.socketTypeScore) {
            socketMainScore = socketMainScore + materialData.socketTypeScore * 1.6;
        }
        if (materialData.socketStatusScore) {
            socketMainScore = socketMainScore + materialData.socketStatusScore * 0.4;
        }
        setMaterialData((prev) => ({ ...prev, socketMainScore: socketMainScore }));
    }, [materialData.socketTypeScore, materialData.socketStatusScore]);

    useEffect(() => {
        var entranceMainScore = 0;
        if (materialData.entranceTypeScore) {
            entranceMainScore = entranceMainScore + materialData.entranceTypeScore * 8;
        }
        if (materialData.entranceStatusScore) {
            entranceMainScore = entranceMainScore + materialData.entranceStatusScore * 2;
        }
        setMaterialData((prev) => ({ ...prev, entranceMainScore: entranceMainScore }));
    }, [materialData.entranceTypeScore, materialData.entranceStatusScore]);

    useEffect(() => {
        var windowMainScore = 0;
        if (materialData.windowTypeScore) {
            windowMainScore = windowMainScore + materialData.windowTypeScore * 8;
        }
        if (materialData.windowStatusScore) {
            windowMainScore = windowMainScore + materialData.windowStatusScore * 2;
        }
        setMaterialData((prev) => ({ ...prev, windowMainScore: windowMainScore }));
    }, [materialData.windowTypeScore, materialData.windowStatusScore]);

    useEffect(() => {
        var faucetsMainScore = 0;
        if (materialData.faucetsTypeScore) {
            faucetsMainScore = faucetsMainScore + materialData.faucetsTypeScore * 8;
        }
        if (materialData.faucetsStatusScore) {
            faucetsMainScore = faucetsMainScore + materialData.faucetsStatusScore * 2;
        }
        setMaterialData((prev) => ({ ...prev, faucetsMainScore: faucetsMainScore }));
    }, [materialData.faucetsTypeScore, materialData.faucetsStatusScore]);

    useEffect(() => {
        var cabinetsMainScore = 0;
        if (materialData.cabinetsTypeScore) {
            cabinetsMainScore = cabinetsMainScore + materialData.cabinetsTypeScore * 8;
        }
        if (materialData.cabinetsStatusScore) {
            cabinetsMainScore = cabinetsMainScore + materialData.cabinetsStatusScore * 2;
        }
        setMaterialData((prev) => ({ ...prev, cabinetsMainScore: cabinetsMainScore }));
    }, [materialData.cabinetsTypeScore, materialData.cabinetsStatusScore]);

    useEffect(() => {
        var doorPhoneMainScore = 0;
        if (materialData.doorPhoneTypeScore) {
            doorPhoneMainScore = doorPhoneMainScore + materialData.doorPhoneTypeScore * 1.6;
        }
        if (materialData.doorPhoneStatusScore) {
            doorPhoneMainScore = doorPhoneMainScore + materialData.doorPhoneStatusScore * 0.4;
        }
        setMaterialData((prev) => ({ ...prev, doorPhoneMainScore: doorPhoneMainScore }));
    }, [materialData.doorPhoneTypeScore, materialData.doorPhoneStatusScore]);

    useEffect(() => {
        var baseMaterialsMainScore = 0;
        if (materialData.ceramicScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.ceramicScore * 5;
        }
        if (materialData.washBasinTypeScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.washBasinTypeScore * 1;
        }
        if (materialData.fwcTypeScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.fwcTypeScore * 4;
        }
        if (materialData.knafKariScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.knafKariScore * 4;
        }
        if (materialData.knafKariQualityScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.knafKariQualityScore * 4;
        }
        if (materialData.knafKariColorScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.knafKariColorScore * 2;
        }
        if (materialData.floorMaterialTypeScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.floorMaterialTypeScore * 6;
        }
        if (materialData.floorMaterialDimensionsScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.floorMaterialDimensionsScore * 2;
        }
        if (materialData.floorMaterialTransparencyScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.floorMaterialTransparencyScore * 2;
        }
        if (materialData.wallAppearanceScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.wallAppearanceScore * 4.5;
        }
        if (materialData.wallpaperQualityScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.wallpaperQualityScore * 0.5;
        }
        if (materialData.heatingSystemTypeScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.heatingSystemTypeScore * 10;
        }
        if (materialData.coolingSystemTypeScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.coolingSystemTypeScore * 10;
        }
        if (materialData.corniceScore) {
            baseMaterialsMainScore = baseMaterialsMainScore + materialData.corniceScore * 1;
        }
        setMaterialData((prev) => ({ ...prev, baseMaterialsMainScore: baseMaterialsMainScore }));
    }, [
        materialData.ceramicScore,
        materialData.washBasinTypeScore,
        materialData.fwcTypeScore,
        materialData.knafKariScore,
        materialData.knafKariQualityScore,
        materialData.knafKariColorScore,
        materialData.floorMaterialTypeScore,
        materialData.floorMaterialDimensionsScore,
        materialData.floorMaterialTransparencyScore,
        materialData.wallAppearanceScore,
        materialData.wallpaperQualityScore,
        materialData.heatingSystemTypeScore,
        materialData.coolingSystemTypeScore,
        materialData.corniceScore,
    ]);
    {
        /* /////////////////////////////////////////////////////////////////// */
    }
    const [moshaatData, setmoshaatData] = useState({
        StairwayMainScore: 0,
        yardMainScore: 0,
        roofMainScore: 0,
        buildingFacadeMainScore: 0,
        parkingMaterialMainScore: 0,
        elevatorMainScore: 0,
        xxxMainScore: 0,
        expertScore: 0,
    });
    function moshaathandleChange(event) {
        // console.log(event);
        var targetId = event.id;
        var targetValue = event.value;
        setmoshaatData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    function moshaathandleNumberInputChange(event) {
        // console.log(event.target.valueAsNumber);
        // console.log(event.target.id);
        var targetId = event.target.id;
        var targetValue = event.target.valueAsNumber;
        setmoshaatData((prev) => ({ ...prev, [targetId]: targetValue }));
    }

    useEffect(() => {
        console.log(moshaatData);
    }, [moshaatData]);

    useEffect(() => {
        var StairwayMainScore = 0;
        if (moshaatData.StairwayWidthScore) {
            StairwayMainScore = StairwayMainScore + moshaatData.StairwayWidthScore * 5.7;
        }
        if (moshaatData.StairwayHeightScore) {
            StairwayMainScore = StairwayMainScore + moshaatData.StairwayHeightScore * 3.8;
        }
        if (moshaatData.StairwayBefitScore) {
            StairwayMainScore = StairwayMainScore + moshaatData.StairwayBefitScore * 1.9;
        }
        if (moshaatData.StairwayMaterialScore) {
            StairwayMainScore = StairwayMainScore + moshaatData.StairwayMaterialScore * 3.8;
        }
        if (moshaatData.stairRailingScore) {
            StairwayMainScore = StairwayMainScore + moshaatData.stairRailingScore * 3.8;
        }
        setmoshaatData((prev) => ({ ...prev, StairwayMainScore: StairwayMainScore }));
    }, [moshaatData.StairwayWidthScore, moshaatData.StairwayHeightScore, moshaatData.StairwayBefitScore, moshaatData.StairwayMaterialScore, moshaatData.stairRailingScore]);

    useEffect(() => {
        var yardMainScore = 0;
        if (moshaatData.yardMaterialScore) {
            yardMainScore = yardMainScore + moshaatData.yardMaterialScore * 7.6;
        }
        if (moshaatData.floricultureScore) {
            yardMainScore = yardMainScore + moshaatData.floricultureScore * 3.8;
        }
        if (moshaatData.rampScore) {
            yardMainScore = yardMainScore + moshaatData.rampScore * 7.6;
        }
        setmoshaatData((prev) => ({ ...prev, yardMainScore: yardMainScore }));
    }, [moshaatData.yardMaterialScore, moshaatData.floricultureScore, moshaatData.rampScore]);

    useEffect(() => {
        var roofMainScore = 0;
        if (moshaatData.roofGardenScore) {
            roofMainScore = roofMainScore + moshaatData.roofGardenScore * 1;
        }
        setmoshaatData((prev) => ({ ...prev, roofMainScore: roofMainScore }));
    }, [moshaatData.roofGardenScore]);

    useEffect(() => {
        var buildingFacadeMainScore = 0;
        if (moshaatData.buildingFacadeScore) {
            buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.buildingFacadeScore * 22.4;
        }
        if (moshaatData.buildingLightingScore) {
            buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.buildingLightingScore * 5.6;
        }
        if (moshaatData.lobbyScore) {
            buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.lobbyScore * 1;
        }
        setmoshaatData((prev) => ({ ...prev, buildingFacadeMainScore: buildingFacadeMainScore }));
    }, [moshaatData.buildingFacadeScore, moshaatData.buildingLightingScore, moshaatData.lobbyScore]);

    useEffect(() => {
        var parkingMaterialMainScore = 0;
        if (moshaatData.parkingMaterialScore) {
            parkingMaterialMainScore = parkingMaterialMainScore + moshaatData.parkingMaterialScore * 15.2;
        }
        if (moshaatData.parkingLightingScore) {
            parkingMaterialMainScore = parkingMaterialMainScore + moshaatData.parkingLightingScore * 3.8;
        }
        setmoshaatData((prev) => ({ ...prev, parkingMaterialMainScore: parkingMaterialMainScore }));
    }, [moshaatData.parkingMaterialScore, moshaatData.parkingLightingScore]);

    useEffect(() => {
        var elevatorMainScore = 0;
        if (moshaatData.elevatorCapacityScore) {
            elevatorMainScore = elevatorMainScore + moshaatData.elevatorCapacityScore * 1.3;
        }
        if (moshaatData.elevatorScore) {
            elevatorMainScore = elevatorMainScore + moshaatData.elevatorScore * 5.2;
        }
        if (moshaatData.elevatorNoiseScore) {
            elevatorMainScore = elevatorMainScore + moshaatData.elevatorNoiseScore * 3.25;
        }
        if (moshaatData.elevatorShakingScore) {
            elevatorMainScore = elevatorMainScore + moshaatData.elevatorShakingScore * 3.25;
        }
        setmoshaatData((prev) => ({ ...prev, elevatorMainScore: elevatorMainScore }));
    }, [moshaatData.elevatorCapacityScore, moshaatData.elevatorScore, moshaatData.elevatorNoiseScore, moshaatData.elevatorShakingScore]);
    {
        /* /////////////////////////////////////////////////////////////////// */
    }
    const [accessibilityData, setAccessibilityData] = useState({
        ganatScore: 0,
        zaminScore: 0,
        farsodeScore: 0,
        mokhaberatScore: 0,
        asiatekScore: 0,
        parsOnlineScore: 0,
        irancellScore: 0,
        hamrahavalScore: 0,
        raightelScore: 0,
        roadMasgedScore: 0,
        roadMadreseScore: 0,
        roadBimarestanScore: 0,
        roadMetroScore: 0,
        roadMarketScore: 0,
        roadMiveScore: 0,
        roadOtobanScore: 0,
        roadBenzinScore: 0,
    });
    function accessibilityHandleChange(event) {
        // console.log(event);
        var targetId = event.id;
        var targetValue = event.value;
        setAccessibilityData((prev) => ({ ...prev, [targetId]: targetValue }));
    }
    function accessibilityHandleNumberInputChange(event) {
        // console.log(event.target.valueAsNumber);
        // console.log(event.target.id);
        var targetId = event.target.id;
        var targetValue = event.target.valueAsNumber;
        setAccessibilityData((prev) => ({ ...prev, [targetId]: targetValue }));
    }

    useEffect(() => {
        console.log(accessibilityData);
    }, [accessibilityData]);

    // useEffect(() => {
    //     var StairwayMainScore = 0;
    //     if (moshaatData.StairwayWidthScore) {
    //         StairwayMainScore = StairwayMainScore + moshaatData.StairwayWidthScore * 5.7;
    //     }
    //     if (moshaatData.StairwayHeightScore) {
    //         StairwayMainScore = StairwayMainScore + moshaatData.StairwayHeightScore * 3.8;
    //     }
    //     if (moshaatData.StairwayBefitScore) {
    //         StairwayMainScore = StairwayMainScore + moshaatData.StairwayBefitScore * 1.9;
    //     }
    //     if (moshaatData.StairwayMaterialScore) {
    //         StairwayMainScore = StairwayMainScore + moshaatData.StairwayMaterialScore * 3.8;
    //     }
    //     if (moshaatData.stairRailingScore) {
    //         StairwayMainScore = StairwayMainScore + moshaatData.stairRailingScore * 3.8;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, StairwayMainScore: StairwayMainScore }));
    // }, [moshaatData.StairwayWidthScore, moshaatData.StairwayHeightScore, moshaatData.StairwayBefitScore, moshaatData.StairwayMaterialScore, moshaatData.stairRailingScore]);

    // useEffect(() => {
    //     var yardMainScore = 0;
    //     if (moshaatData.yardMaterialScore) {
    //         yardMainScore = yardMainScore + moshaatData.yardMaterialScore * 7.6;
    //     }
    //     if (moshaatData.floricultureScore) {
    //         yardMainScore = yardMainScore + moshaatData.floricultureScore * 3.8;
    //     }
    //     if (moshaatData.rampScore) {
    //         yardMainScore = yardMainScore + moshaatData.rampScore * 7.6;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, yardMainScore: yardMainScore }));
    // }, [moshaatData.yardMaterialScore, moshaatData.floricultureScore, moshaatData.rampScore]);

    // useEffect(() => {
    //     var roofMainScore = 0;
    //     if (moshaatData.roofGardenScore) {
    //         roofMainScore = roofMainScore + moshaatData.roofGardenScore * 1;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, roofMainScore: roofMainScore }));
    // }, [moshaatData.roofGardenScore]);

    // useEffect(() => {
    //     var buildingFacadeMainScore = 0;
    //     if (moshaatData.buildingFacadeScore) {
    //         buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.buildingFacadeScore * 22.4;
    //     }
    //     if (moshaatData.buildingLightingScore) {
    //         buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.buildingLightingScore * 5.6;
    //     }
    //     if (moshaatData.lobbyScore) {
    //         buildingFacadeMainScore = buildingFacadeMainScore + moshaatData.lobbyScore * 1;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, buildingFacadeMainScore: buildingFacadeMainScore }));
    // }, [moshaatData.buildingFacadeScore, moshaatData.buildingLightingScore, moshaatData.lobbyScore]);

    // useEffect(() => {
    //     var parkingMaterialMainScore = 0;
    //     if (moshaatData.parkingMaterialScore) {
    //         parkingMaterialMainScore = parkingMaterialMainScore + moshaatData.parkingMaterialScore * 15.2;
    //     }
    //     if (moshaatData.parkingLightingScore) {
    //         parkingMaterialMainScore = parkingMaterialMainScore + moshaatData.parkingLightingScore * 3.8;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, parkingMaterialMainScore: parkingMaterialMainScore }));
    // }, [moshaatData.parkingMaterialScore, moshaatData.parkingLightingScore]);

    // useEffect(() => {
    //     var elevatorMainScore = 0;
    //     if (moshaatData.elevatorCapacityScore) {
    //         elevatorMainScore = elevatorMainScore + moshaatData.elevatorCapacityScore * 1.3;
    //     }
    //     if (moshaatData.elevatorScore) {
    //         elevatorMainScore = elevatorMainScore + moshaatData.elevatorScore * 5.2;
    //     }
    //     if (moshaatData.elevatorNoiseScore) {
    //         elevatorMainScore = elevatorMainScore + moshaatData.elevatorNoiseScore * 3.25;
    //     }
    //     if (moshaatData.elevatorShakingScore) {
    //         elevatorMainScore = elevatorMainScore + moshaatData.elevatorShakingScore * 3.25;
    //     }
    //     setmoshaatData((prev) => ({ ...prev, elevatorMainScore: elevatorMainScore }));
    // }, [moshaatData.elevatorCapacityScore, moshaatData.elevatorScore, moshaatData.elevatorNoiseScore, moshaatData.elevatorShakingScore]);

    return (
        <div className="BaaHam_NormalUsers_SabteAgahi">
            {/* /////////////////////////////////////////////////////////////////// */}
            {/* /////////////////////////////////////////////////////////////////// */}
            <div className="BaaHam_NU_SabteAgahiMoreFeaturesTitle">
                <span>اطلاعات تکمیلی</span>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        متراژ<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد اتاق <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سال ساخت <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput"></input>
                    </div>
                </div>

                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        طبقه <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input type={"Number"} id="floor" className="BaaHam_NU_SabteAgahiBottomGridInput"></input>
                    </div>
                </div>
                <br />
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آسانسور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            id="elevator"
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { label: "دارد", value: "دارد" },
                                { label: "ندارد", value: "ندارد" },
                            ]}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            id="parking"
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { label: "دارد", value: "دارد" },
                                { label: "ندارد", value: "ندارد" },
                            ]}
                        ></Select>
                        {/* <input id="parking" className='BaaHam_NU_SabteAgahiBottomGridInput'></input> */}
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        انباری <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            id="warehouse"
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { label: "دارد", value: "دارد" },
                                { label: "ندارد", value: "ندارد" },
                            ]}
                        ></Select>
                        {/* <input id="warehouse" className='BaaHam_NU_SabteAgahiBottomGridInput'></input> */}
                    </div>
                </div>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آدرس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput"></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3", marginTop: "24px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        محله<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "mahalleh", label: "Abazar", value: "Abazar" },
                                { id: "mahalleh", label: "Almahdi", value: "Almahdi" },
                                { id: "mahalleh", label: "Andisheh", value: "Andisheh" },
                                { id: "mahalleh", label: "Aseman", value: "Aseman" },
                                { id: "mahalleh", label: "Baghe Feyz", value: "Baghe Feyz" },
                                { id: "mahalleh", label: "Baharan", value: "Baharan" },
                                { id: "mahalleh", label: "Can", value: "Can" },
                                { id: "mahalleh", label: "Daneshgah Sharif", value: "Daneshgah Sharif" },
                                { id: "mahalleh", label: "Darya", value: "Darya" },
                                { id: "mahalleh", label: "DaryanNo", value: "DaryanNo" },
                                { id: "mahalleh", label: "Ekbatan", value: "Ekbatan" },
                                { id: "mahalleh", label: "Eram", value: "Eram" },
                                { id: "mahalleh", label: "Eyvanak", value: "Eyvanak" },
                                { id: "mahalleh", label: "Farahzad", value: "Farahzad" },
                                { id: "mahalleh", label: "Gisha", value: "Gisha" },
                                { id: "mahalleh", label: "Hesarak", value: "Hesarak" },
                                { id: "mahalleh", label: "JannatAbad Jonubi", value: "JannatAbad Jonubi" },
                                { id: "mahalleh", label: "JannatAbad Markazi", value: "JannatAbad Markazi" },
                                { id: "mahalleh", label: "JannatAbad Shomali", value: "JannatAbad Shomali" },
                                { id: "mahalleh", label: "Kuye Bimeh", value: "Kuye Bimeh" },
                                { id: "mahalleh", label: "Kuye Faraz", value: "Kuye Faraz" },
                                { id: "mahalleh", label: "Kuye Ferdows", value: "Kuye Ferdows" },
                                { id: "mahalleh", label: "Kuye Mehran", value: "Kuye Mehran" },
                                { id: "mahalleh", label: "Marzdaran", value: "Marzdaran" },
                                { id: "mahalleh", label: "MoradAbad", value: "MoradAbad" },
                                { id: "mahalleh", label: "Parvaz", value: "Parvaz" },
                                { id: "mahalleh", label: "Patris Lomumba", value: "Patris Lomumba" },
                                { id: "mahalleh", label: "Punak", value: "Punak" },
                                { id: "mahalleh", label: "Saadat Abad", value: "Saadat Abad" },
                                { id: "mahalleh", label: "Sadeghieh", value: "Sadeghieh" },
                                { id: "mahalleh", label: "SattarKhan", value: "SattarKhan" },
                                { id: "mahalleh", label: "Sazman Ab", value: "Sazman Ab" },
                                { id: "mahalleh", label: "Sazman Barnameh", value: "Sazman Barnameh" },
                                { id: "mahalleh", label: "Sepehr", value: "Sepehr" },
                                { id: "mahalleh", label: "Shadmehr", value: "Shadmehr" },
                                { id: "mahalleh", label: "Shahin", value: "Shahi" },
                                { id: "mahalleh", label: "ShahrAra", value: "ShahrAra" },
                                { id: "mahalleh", label: "Shahrak Apadana", value: "Shahrak Apadana" },
                                { id: "mahalleh", label: "Shahrak Kuhsar", value: "Shahrak Kuhsar" },
                                { id: "mahalleh", label: "Shahrak Naft", value: "Shahrak Naft" },
                                { id: "mahalleh", label: "Shahrak Parvaz", value: "Shahrak Parvaz" },
                                { id: "mahalleh", label: "Shahrak Zhandarmeri", value: "Shahrak Zhandarmeri" },
                                { id: "mahalleh", label: "Shahrak e Gharb", value: "Shahrak e Gharb" },
                                { id: "mahalleh", label: "Shahran Shomali", value: "Shahran Shomali" },
                                { id: "mahalleh", label: "Shahran jonubi", value: "Shahran jonubi" },
                                { id: "mahalleh", label: "Shahre Ziba", value: "Shahre Ziba" },
                                { id: "mahalleh", label: "Tarasht", value: "Tarasht" },
                                { id: "mahalleh", label: "TehranVilla", value: "TehranVilla" },
                                { id: "mahalleh", label: "Tohid", value: "Tohid" },
                            ]}
                            onChange={mahallehHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3", marginTop: "24px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        Location Code 1<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select placeholder="" styles={customStyles} options={locationCodeList} onChange={locationCode1handleChange}></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "24px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        Location Code 2<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select placeholder="" styles={customStyles} options={locationCodeList} onChange={locationCode2handleChange}></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3", marginTop: "24px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        Location Code 3<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select placeholder="" styles={customStyles} options={locationCodeList} onChange={locationCode3handleChange}></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "24px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        Location Code 4<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select placeholder="" styles={customStyles} options={locationCodeList} onChange={locationCode4handleChange}></Select>
                    </div>
                </div>
            </div>

            <div className="BaaHam_NormalUsers_SabteAgahiButton1" style={{ marginTop: "24px" }}>
                <span>ثبت جزئیات ملک</span>
            </div>
            {/* /////////////////////////////////////////////////////////////////// */}
            {/* /////////////////////////////////////////////////////////////////// */}
            <div className="BaaHam_NU_SabteAgahiMoreFeaturesTitle">
                <span>نقشه ملک</span>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>سالن پذیرایی : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تناسب ابعاد سالن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "hallDimensionsProportion", label: "سالن اتوبوسی", value: "سالن اتوبوسی" },
                                { id: "hallDimensionsProportion", label: "متوسط", value: "متوسط" },
                                { id: "hallDimensionsProportion", label: "ابعاد مانند فیثاغورس یا مربع", value: "ابعاد مانند فیثاغورس یا مربع" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره سالن<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"hallDimensionsScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        مساحت سالن پذیرایی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"hallDimensionsArea"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        مساحت واحد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"buildingArea"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ارتفاع سقف (مترمربع)<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"ceilingHeight"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ارتفاع سقف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"ceilingHeightScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        قناسی در سالن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "hallDimensionsCrooked", label: "دارد", value: "دارد" },
                                { id: "hallDimensionsCrooked", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره قناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"hallDimensionsCrookedScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.hallMainScore.toFixed(2)}</span> از <span>28</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>آشپزخانه : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        مساحت آشپزخانه<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"kitchenArea"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره دسترسی به آشپزخانه<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"kitchenUseScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره تناسب ابعاد آشپزخانه<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"kitchenProportion"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        قناسی در آشپزخانه <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "kitchenCrooked", label: "دارد", value: "دارد" },
                                { id: "kitchenCrooked", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره قناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"kitchenCrookedScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.kitchenMainScore.toFixed(2)}</span> از <span>24</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>اتاق خواب : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد اتاق خواب<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsNumber"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره اتاق خواب<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        قرارگیری وسایل ضروری <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder="کمد ، تخت خواب و ... جا می شود"
                            styles={customStyles}
                            options={[
                                { id: "bedroomsPlacement", label: "بلی", value: "بلی" },
                                { id: "bedroomsPlacement", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        قناسی در اتاق خواب <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "bedroomsCrooked", label: "دارد", value: "دارد" },
                                { id: "bedroomsCrooked", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        هیچ یک از اظلاع اتاق خواب کمتر از 2 متر نیست<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "bedroomsLess2m", label: "بلی", value: "بلی" },
                                { id: "bedroomsLess2m", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره قناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsCrookedScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اتاق خواب رو به خیابان است و فضای شب آرامی دارد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "bedroomsAtmosphere", label: "بلی", value: "بلی" },
                                { id: "bedroomsAtmosphere", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اتاق خواب آرام<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsAtmosphereScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اتاق خواب دارای کمد دیواری است و یا جا برای کمد دارد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "bedroomsWallCloset", label: "بلی", value: "بلی" },
                                { id: "bedroomsWallCloset", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کمد دیواری<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsWallClosetScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اتاق خواب مستر<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "bedroomsMaster", label: "دارد", value: "دارد" },
                                { id: "bedroomsMaster", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره خواب مستر<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomsMasterScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.bedroomsMainScore.toFixed(2)}</span> از <span>16</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>سرویس بهداشتی ایرانی و مهمان : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سرویس ایرانی نزدیک در ورود است<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "iwcEntrance", label: "بله", value: "بله" },
                                { id: "iwcEntrance", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره سرویس ایرانی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"iwcSCore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        با بازشدن در ورودی سرویس ایرانی دیده می شود<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "iwcPlacement", label: "بله", value: "بله" },
                                { id: "iwcPlacement", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ورودی سالن<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"iwcPlacementScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سرویس نزدیک اتاق خواب است<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "iwcNearBedroom", label: "بله", value: "بله" },
                                { id: "iwcNearBedroom", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره نزدیک اتاق خواب بودن<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"iwcNearBedroomScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.iwcMainScore.toFixed(2)}</span> از <span>4</span>{" "}
                    </p>
                </div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>سرویس فرنگی : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سرویس فرنگی نزدیک در ورودی است<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "fwcEntrance", label: "بله", value: "بله" },
                                { id: "fwcEntrance", label: "خیر", value: "خیر" },
                                { id: "fwcEntrance", label: "ملک سرویس فرنگی ندارد", value: "ملک سرویس فرنگی ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره سرویس فرنگی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"fwcScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        با باز شدن در ورودی سرویس فرنگی دیده می شود<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "fwcPlacement", label: "بله", value: "بله" },
                                { id: "fwcPlacement", label: "خیر", value: "خیر" },
                                { id: "fwcPlacement", label: "ملک سرویس فرنگی ندارد", value: "ملک سرویس فرنگی ندارد" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ورودی سالن<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"fwcPlacementScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سرویس فرنگی نزدیک اتاق خواب است<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "fwcNearBedroom", label: "بله", value: "بله" },
                                { id: "fwcNearBedroom", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره نزدیک اتاق خواب بودن<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"fwcNearBedroomScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.fwcMainScore.toFixed(2)}</span> از <span>4</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <p style={{ fontWeight: "bold" }}>دیوار مشترک : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اتاق خواب دیوار مشترک دارد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "wallBedroom", label: "بله", value: "بله" },
                                { id: "wallBedroom", label: "خیر", value: "خیر" },
                            ]}
                            onChange={hallhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره اتاق و دیوار مشترک<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"wallBedroomScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{hallData.wallBedroomMainScore.toFixed(2)}</span> از <span>4</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <p style={{ fontWeight: "bold" }}>نمره ارزیابی شخصی کارشناس به نقشه : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span style={{ fontWeight: "normal", fontSize: "12px", textAlign: "center", width: "100%" }}>نمره محسبه شده فیلد های بخش نقشه</span>
                    <span style={{ fontWeight: "bold", fontSize: "32px", marginTop: "2px", textAlign: "center", width: "100%" }}>
                        {(hallData.hallMainScore + hallData.kitchenMainScore + hallData.bedroomsMainScore + hallData.iwcMainScore + hallData.fwcMainScore + hallData.wallBedroomMainScore).toFixed(2)}
                    </span>
                    <span style={{ fontWeight: "normal", fontSize: "24px", textAlign: "center", width: "100%" }}> +</span>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ارزیابی شخصی کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"expertScore"} onChange={hallhandleNumberInputChange}></input>
                    </div>
                </div>
            </div>

            <div className="BaaHam_NormalUsers_SabteAgahiButton1" style={{ marginTop: "24px" }}>
                <span>ثبت نقشه ملک</span>
            </div>
            {/* /////////////////////////////////////////////////////////////////// */}
            {/* /////////////////////////////////////////////////////////////////// */}
            <div className="BaaHam_NU_SabteAgahiMoreFeaturesTitle">
                <span>متریال داخلی</span>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع کلید و پریز <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "socketType", label: "مکانیکی", value: "مکانیکی" },
                                { id: "socketType", label: "اهرمی", value: "اهرمی" },
                                { id: "socketType", label: "لمسی", value: "لمسی" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"socketTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت کلید و پریز<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "socketStatus", label: "کهنه", value: "کهنه" },
                                { id: "socketStatus", label: "نو", value: "نو" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"socketStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.socketMainScore.toFixed(2)}</span> از <span>4</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع درب ورود <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "entranceType", label: "درب عادی برای درب اصلی و درب سرویس بهداشتی و حمام", value: "درب عادی برای درب اصلی و درب سرویس بهداشتی و حمام" },
                                { id: "entranceType", label: "درب عادی برای درب اصلی یا درب سرویس بهداشتی و حمام", value: "درب عادی برای درب اصلی یا درب سرویس بهداشتی و حمام" },
                                { id: "entranceType", label: "درب ضد سرقت برای درب اصلی و درب ضد اب برای سرویس بهداشتی و حمام", value: "درب ضد سرقت برای درب اصلی و درب ضد اب برای سرویس بهداشتی و حمام" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"entranceTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت درب ها<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "entranceStatus", label: "کهنه", value: "کهنه" },
                                { id: "entranceStatus", label: "نو", value: "نو" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"entranceStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.entranceMainScore.toFixed(2)}</span> از <span>20</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع پنجره <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "windowType", label: "پنجره عادی", value: "پنجره عادی" },
                                { id: "windowType", label: "پنجره دوجداره برندهای غیر مشهور", value: "پنجره دوجداره برندهای غیر مشهور" },
                                { id: "windowType", label: "پنجره دوجداره برند های مشهور", value: "پنجره دوجداره برند های مشهور" },
                                { id: "windowType", label: "پنجره ترمال بریک", value: "پنجره ترمال بریک" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"windowTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت پنجره ها<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "windowStatus", label: "کهنه", value: "کهنه" },
                                { id: "windowStatus", label: "نو", value: "نو" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"windowStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.windowMainScore.toFixed(2)}</span> از <span>20</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع شیرآلات <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "faucetsType", label: "متفرقه", value: "متفرقه" },
                                { id: "faucetsType", label: "برند مشهور", value: "برند مشهور" },
                                { id: "faucetsType", label: "برند لاکچری خارجی", value: "برند لاکچری خارجی" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"faucetsTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت شیرآلات<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "faucetsStatus", label: "کهنه", value: "کهنه" },
                                { id: "faucetsStatus", label: "نو", value: "نو" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"faucetsStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.faucetsMainScore.toFixed(2)}</span> از <span>20</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع کابینت <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "cabinetsType", label: "کابینت فلزی", value: "کابینت فلزی" },
                                { id: "cabinetsType", label: "کابینت ام دی اف", value: "کابینت ام دی اف" },
                                { id: "cabinetsType", label: "کابینت های گلس ایرانی", value: "کابینت های گلس ایرانی" },
                                { id: "cabinetsType", label: "کابینت های گلس ترک و فرامید و ممبران ایرانی", value: "کابینت های گلس ترک و فرامید و ممبران ایرانی" },
                                { id: "cabinetsType", label: "کابینت ممبران خارجی", value: "کابینت ممبران خارجی" },
                                { id: "cabinetsType", label: "ملک کابینت ندارد", value: "ملک کابینت ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"cabinetsTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>

                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت کابینت<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "cabinetsStatus", label: "کهنه", value: "کهنه" },
                                { id: "cabinetsStatus", label: "نو", value: "نو" },
                                { id: "cabinetsStatus", label: "ملک کابینت ندارد", value: "ملک کابینت ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"cabinetsStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.cabinetsMainScore.toFixed(2)}</span> از <span>20</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع برند آیفون تصویری<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "doorPhoneType", label: "سایز صفحه نمایش آیفون بیشتر از 4.5 اینچ", value: "سایز صفحه نمایش آیفون بیشتر از 4.5 اینچ" },
                                { id: "doorPhoneType", label: "سایز صفحه نمایش آیفون کمتر از 4.5 اینچ", value: "سایز صفحه نمایش آیفون کمتر از 4.5 اینچ" },
                                { id: "doorPhoneType", label: "ملک آیفون تصویری ندارد", value: "ملک آیفون تصویری ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سایز صفحه نمایش<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"doorPhoneSize"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"doorPhoneTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت آیفون تصویری<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "doorPhoneStatus", label: "کهنه", value: "کهنه" },
                                { id: "doorPhoneStatus", label: "نو", value: "نو" },
                                { id: "doorPhoneStatus", label: "ملک آیفون تصویری ندارد", value: "ملک آیفون تصویری ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"doorPhoneStatusScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.doorPhoneMainScore.toFixed(2)}</span> از <span>4</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "12px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px #b2bec3" }}></div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        جنس سرامیک کف و دیوار<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                            <input className="BaaHam_NU_SabteAgahiBottomGridInput" value={"بازه بین 0.25 تا 2 بسته به نظر کارشناس"} disabled></input>
                        </div>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"ceramicScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع روشویی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "washBasinType", label: "قدیمی", value: "قدیمی" },
                                { id: "washBasinType", label: "امروزی", value: "امروزی" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"washBasinTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع توالت فرنگی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "fwcType", label: "توکار", value: "توکار" },
                                { id: "fwcType", label: "روکار", value: "روکار" },
                                { id: "fwcType", label: "ملک توالت فرنگی ندارد", value: "ملک توالت فرنگی ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"fwcTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کناف کاری در سقف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "knafKari", label: "دارد", value: "دارد" },
                                { id: "knafKari", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"knafKariScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کیفیت و ظرافت کناف کاری<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                            <input className="BaaHam_NU_SabteAgahiBottomGridInput" value={"بازه بین 0.25 تا 2 بسته به نظر کارشناس"} disabled></input>
                        </div>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"knafKariQualityScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کیفیت رنگ کاری سقف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                            <input className="BaaHam_NU_SabteAgahiBottomGridInput" value={"بازه بین 0.25 تا 2 بسته به نظر کارشناس"} disabled></input>
                        </div>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"knafKariColorScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع متریال کف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "floorMaterialType", label: "سرامیک با درجه سه یا موزاییک", value: "سرامیک با درجه سه یا موزاییک" },
                                { id: "floorMaterialType", label: "سرامیک با درجه دو", value: "سرامیک با درجه دو" },
                                { id: "floorMaterialType", label: "سرامیک با درجه یک", value: "سرامیک با درجه یک" },
                                { id: "floorMaterialType", label: "سنگ اسلب یا پارکت یا لمینت یا کفپوش", value: "سنگ اسلب یا پارکت یا لمینت یا کفپوش" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floorMaterialTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ابعاد متریال کف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "floorMaterialDimensions", label: "20 در 20", value: "20 در 20" },
                                { id: "floorMaterialDimensions", label: "30 در 30 تا 40 در 40", value: "30 در 30 تا 40 در 40" },
                                { id: "floorMaterialDimensions", label: "50 در 50 تا 60 در 60", value: "50 در 50 تا 60 در 60" },
                                { id: "floorMaterialDimensions", label: "70 در 70 تا 90 در 90", value: "70 در 70 تا 90 در 90" },
                                { id: "floorMaterialDimensions", label: "ابعاد 1 متر در 1 متر و به بالا", value: "ابعاد 1 متر در 1 متر و به بالا" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floorMaterialDimensionsScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        میزان شفافیت متریال کف<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "floorMaterialTransparency", label: "زیاد", value: "زیاد" },
                                { id: "floorMaterialTransparency", label: "متوسط", value: "متوسط" },
                                { id: "floorMaterialTransparency", label: "کم", value: "کم" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floorMaterialTransparencyScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سلامت ظاهری دیوار<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                            <input className="BaaHam_NU_SabteAgahiBottomGridInput" value={"بازه بین 0.25 تا 2 بسته به نظر کارشناس"} disabled></input>
                        </div>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"wallAppearanceScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کاغذ دیواری دارد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "wallpaper", label: "دارد", value: "دارد" },
                                { id: "wallpaper", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کیفیت و سلامت کاغذ دیواری<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "wallpaperQuality", label: "عدم استفاده از کاغذ دیواری", value: "عدم استفاده از کاغذ دیواری" },
                                { id: "wallpaperQuality", label: "استفاده از کاغذ دیواری", value: "استفاده از کاغذ دیواری" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"wallpaperQualityScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع سیستم گرمایشی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "heatingSystemType", label: "بخاری", value: "بخاری" },
                                { id: "heatingSystemType", label: "موتورخانه", value: "موتورخانه" },
                                { id: "heatingSystemType", label: "پکیج", value: "پکیج" },
                                { id: "heatingSystemType", label: "چیلر", value: "چیلر" },
                                { id: "heatingSystemType", label: "داکت اسپلیت", value: "داکت اسپلیت" },
                                { id: "heatingSystemType", label: "در ملک سیستم گرمایشی نصب نشده است", value: "در ملک سیستم گرمایشی نصب نشده است" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"heatingSystemTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع سیستم سرمایشی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "coolingSystemType", label: "کولرآبی", value: "کولرآبی" },
                                { id: "coolingSystemType", label: "کولرگازی", value: "کولرگازی" },
                                { id: "coolingSystemType", label: "چیلر", value: "چیلر" },
                                { id: "coolingSystemType", label: "داکت اسپلیت", value: "داکت اسپلیت" },
                                { id: "coolingSystemType", label: "در ملک سیستم گرمایشی نصب نشده است", value: "در ملک سیستم گرمایشی نصب نشده است" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"coolingSystemTypeScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        قرنیز<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "cornice", label: "دارد", value: "دارد" },
                                { id: "cornice", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={materialhandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"corniceScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{materialData.baseMaterialsMainScore.toFixed(2)}</span> از <span>112</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    {/* <p style={{ fontWeight: "bold" }}>نمره ارزیابی شخصی کارشناس به متریال داخلی : </p> */}
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span style={{ fontWeight: "normal", fontSize: "12px", textAlign: "center", width: "100%" }}>نمره محسبه شده فیلد های بخش متریال داخلی</span>
                    <span style={{ fontWeight: "bold", fontSize: "32px", marginTop: "2px", textAlign: "center", width: "100%" }}>
                        {(materialData.socketMainScore + materialData.entranceMainScore + materialData.windowMainScore + materialData.faucetsMainScore + materialData.cabinetsMainScore + materialData.doorPhoneMainScore + materialData.baseMaterialsMainScore).toFixed(2)}
                    </span>
                    <span style={{ fontWeight: "normal", fontSize: "24px", textAlign: "center", width: "100%" }}> 20/ </span>
                </div>
                {/* <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ارزیابی شخصی کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"expertScore"} onChange={materialhandleNumberInputChange}></input>
                    </div>
                </div> */}
            </div>

            <div className="BaaHam_NormalUsers_SabteAgahiButton1" style={{ marginTop: "24px" }}>
                <span>ثبت متریال داخلی</span>
            </div>
            {/* /////////////////////////////////////////////////////////////////// */}
            {/* /////////////////////////////////////////////////////////////////// */}
            <div className="BaaHam_NU_SabteAgahiMoreFeaturesTitle">
                <span>مشاعات</span>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>راه پله : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        عرض راه پله ( متر ) <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "StairwayWidth", label: "کمتر از 110 سانت ( برای ساختمان های کمتر از 50 نفر 90 سانت )", value: "کمتر از 110 سانت ( برای ساختمان های کمتر از 50 نفر 90 سانت )" },
                                { id: "StairwayWidth", label: "بیشتر از 110 سانت ( برای ساختمان های کمتر از 50 نفر 90 سانت )", value: "بیشتر از 110 سانت ( برای ساختمان های کمتر از 50 نفر 90 سانت )" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"StairwayWidthScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ارتفاع پله ( متر ) <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "StairwayHeight", label: "کمتر از 17 یا بیشتر از 19 سانتی متر", value: "کمتر از 17 یا بیشتر از 19 سانتی متر" },
                                { id: "StairwayHeight", label: "بین 17 تا 19 سانتی متر", value: "بین 17 تا 19 سانتی متر" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"StairwayHeightScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        مناسب بودن عرض پاگرد<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "StairwayBefit", label: "کمتر از 110 سانت", value: "کمتر از 110 سانت" },
                                { id: "StairwayBefit", label: "برابر یا بیشتر از 110 سانت", value: "برابر یا بیشتر از 110 سانت" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"StairwayBefitScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        جنس متریال در کف و دیوار<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                {
                                    id: "StairwayMaterial",
                                    label: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار و تمیزی کف و دیوار راه پله) بسته به نظر کارشناس",
                                    value: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار و تمیزی کف و دیوار راه پله) بسته به نظر کارشناس",
                                },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"StairwayMaterialScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نرده پله<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "stairRailing", label: "دارد", value: "دارد" },
                                { id: "stairRailing", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div Name="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", textAlign: "right" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        جنس نرده<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "stairRailingType", label: "نرده قدیمی آهنی", value: " نرده قدیمی آهنی" },
                                { id: "stairRailingType", label: "نرده جدید(استیل) بدون داشتن حداقل ارتفاع 80 سانت", value: "نرده جدید(استیل) بدون داشتن حداقل ارتفاع 80 سانت" },
                                { id: "stairRailingType", label: "نرده جدید(استیل) با داشتن حداقل ارتفاع 80 سانت", value: "نرده جدید(استیل) با داشتن حداقل ارتفاع 80 سانت" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ارتفاع نرده<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "stairRailingHeight", label: "حداقل 80 سانت است", value: "حداقل 80 سانت است" },
                                { id: "stairRailingHeight", label: "کمتر از 80 سانت است", value: "کمتر از 80 سانت است" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به نرده<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"stairRailingScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.StairwayMainScore.toFixed(2)}</span> از <span>38</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>حیاط : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        جنس متریال بکاررفته در کف و دیوار حیاط<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                {
                                    id: "yardMaterial",
                                    label: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار حیاط و تمیزی کف و دیوار حیاط) بسته به نظر کارشناس",
                                    value: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار حیاط و تمیزی کف و دیوار حیاط) بسته به نظر کارشناس",
                                },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس به متریال<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"yardMaterialScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فضای گلکاری و تزیینات استفاده شده <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "floriculture", label: "دارد", value: "دارد" },
                                { id: "floriculture", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floricultureScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        در رمپ ماشین برای دور گرفتن مشکل دارد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "ramp", label: "بله", value: "بله" },
                                { id: "ramp", label: "خیر", value: "خیر" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"rampScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.yardMainScore.toFixed(2)}</span> از <span>38</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>پشت بام : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        روف گاردن و تزئینات <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "roofGarden", label: "دارد", value: "دارد" },
                                { id: "roofGarden", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roofGardenScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.roofMainScore.toFixed(2)}</span> از <span>2</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>نما و لابی : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع نما و وضعیت کیفی مصالح بکاررفته <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[{ id: "buildingFacade", label: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در نما و تمیزی نما) بسته به نظر کارشناس", value: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در نما و تمیزی نما) بسته به نظر کارشناس" }]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به نما <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"buildingFacadeScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نورپردازی در نما <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "buildingLighting", label: "دارد", value: "دارد" },
                                { id: "buildingLighting", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"buildingLightingScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        لابی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "lobby", label: "دارد", value: "دارد" },
                                { id: "lobby", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"lobbyScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.buildingFacadeMainScore.toFixed(2)}</span> از <span>58</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>متریال پارکینگ : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نوع نما و وضعیت کیفی مصالح بکاررفته <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                {
                                    id: "parkingMaterial",
                                    label: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار پارکینگ و تمیزی پارکینگ) بسته به نظر کارشناس",
                                    value: "بازه بین 0.25 تا 2  (بسته به سن ساختمان و جنس  متریال  بکار رفته در کف و دیوار پارکینگ و تمیزی پارکینگ) بسته به نظر کارشناس",
                                },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به متریال پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingMaterialScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        کناف کاری در پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "parkingKanaf", label: "دارد", value: "دارد" },
                                { id: "parkingKanaf", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                {/* <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingKanafScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div> */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نورپردازی در سقف پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "parkingLighting", label: "دارد", value: "دارد" },
                                { id: "parkingLighting", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingLightingScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.parkingMaterialMainScore.toFixed(2)}</span> از <span>38</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>آسانسور : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ظرفیت آسانسور مناسب برای تعداد ساکنین <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "elevatorCapacity", label: "است", value: "است" },
                                { id: "elevatorCapacity", label: "نیست", value: "نیست" },
                                { id: "elevatorCapacity", label: "آسانسور ندارد", value: "آسانسور ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"elevatorCapacityScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        وضعیت تمیزی و نو بودن آسانسور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "elevatorCleanliness", label: "است", value: "است" },
                                { id: "elevatorCleanliness", label: "نیست", value: "نیست" },
                                { id: "elevatorCleanliness", label: "آسانسور ندارد", value: "آسانسور ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به آسانسور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"elevatorScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آسانسور در حین حرکت صدای غیر طبیعی دارد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "elevatorNoise", label: "بله", value: "بله" },
                                { id: "elevatorNoise", label: "خیر", value: "خیر" },
                                { id: "elevatorNoise", label: "آسانسور ندارد", value: "آسانسور ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به آسانسور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"elevatorNoiseScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آسانسور حین حرکت یا ایستادن لرزش دارد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "elevatorShaking", label: "بله", value: "بله" },
                                { id: "elevatorShaking", label: "خیر", value: "خیر" },
                                { id: "elevatorShaking", label: "آسانسور ندارد", value: "آسانسور ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5", marginTop: "8px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناسی به آسانسور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"elevatorShakingScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>
                        امتیاز : <span>{moshaatData.elevatorMainScore.toFixed(2)}</span> از <span>26</span>{" "}
                    </p>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>تعداد واحد و طبقه : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        طبقه ای که واحد در آن قرار دارد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floor"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد کل طبقات <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"floorsCount"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد واحد در هر طبقه <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"unitInFloor"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>پارکینگ : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ابعاد پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingArea"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingNumber"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد پارکینگ مزاحم <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"badParkingNumber"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد پارکینگ غیرمزاحم <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"goodParkingNumber"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        ارتفاع سقف پارکینگ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingHeight"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        طبقه ای که پارکینگ در آن است <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"parkingFloor"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>انباری : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        انباری <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "warehouse", label: "دارد", value: "دارد" },
                                { id: "warehouse", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"warehouseScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        متراژ انباری <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"warehouseArea"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"warehouseAreaScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>اتاق خواب : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد اتاق خواب <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomNumber"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        متراژ کل واحد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"bedroomArea"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>متراژ : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        متراژ <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"Area"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"AreaScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>بالکن : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        بالکن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "balcony", label: "دارد", value: "دارد" },
                                { id: "balcony", label: "ندارد", value: "ندارد" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"balconyScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        متراژ بالکن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"balconyArea"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"balconyAreaScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>سن بنا : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سن بنا <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"buildingAge"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>بازسازی : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آیا بازسازی می خواهد <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "needRebuilding", label: "بله", value: "بله" },
                                { id: "needRebuilding", label: "خیر", value: "خیر" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آیا بازسازی شده <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "rebuilding", label: "بله", value: "بله" },
                                { id: "rebuilding", label: "خیر", value: "خیر" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>قدرالسهم : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        تعداد طبقات <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"allFloorNumber"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"allFloorNumberScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سالن پرده خور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "curtain", label: "است", value: "است" },
                                { id: "curtain", label: "نیست", value: "نیست" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره کارشناس <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"curtainScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        پهنه <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "width", label: "R112", value: "R112" },
                                { id: "width", label: "R121", value: "R121" },
                                { id: "width", label: "R122", value: "R122" },
                                { id: "width", label: "R131", value: "R131" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        سهم از اعیان <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "contribution ", label: "یک از نه", value: "یک از نه" },
                                { id: "contribution ", label: "یک از هشت ", value: "یک از هشت " },
                                { id: "contribution ", label: "یک از شش", value: "یک از شش" },
                                { id: "contribution ", label: "یک از چهار ", value: "یک از چهار " },
                                { id: "contribution ", label: "یک از سه ", value: "یک از سه " },
                                { id: "contribution ", label: " یک از دو ", value: " یک از دو " },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        جهت ملک <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "direction", label: "شمال", value: "شمال" },
                                { id: "direction", label: "غرب", value: "غرب" },
                                { id: "direction", label: "جنوب", value: "جنوب" },
                                { id: "direction", label: "شرق", value: "شرق" },
                            ]}
                            onChange={moshaathandleChange}
                        ></Select>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
                    <p style={{ fontWeight: "bold" }}>نمره ارزیابی شخصی کارشناس به مشاعات : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "5" }}>
                    <span style={{ fontWeight: "normal", fontSize: "12px", textAlign: "center", width: "100%" }}>نمره محسبه شده فیلد های بخش مشاعات</span>
                    <span style={{ fontWeight: "bold", fontSize: "32px", marginTop: "2px", textAlign: "center", width: "100%" }}>8</span>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        نمره ارزیابی شخصی کارشناس<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"expertScore"} onChange={moshaathandleNumberInputChange}></input>
                    </div>
                </div>
            </div>

            <div className="BaaHam_NormalUsers_SabteAgahiButton1" style={{ marginTop: "24px" }}>
                <span>ثبت مشاعات</span>
            </div>
            {/* /////////////////////////////////////////////////////////////////// */}
            {/* /////////////////////////////////////////////////////////////////// */}
            <div className="BaaHam_NU_SabteAgahiMoreFeaturesTitle">
                <span>دسترسی پذیری</span>
            </div>
            <div className="BaaHam_NU_SabteAgahiBottomGrids" style={{ marginTop: "24px", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>استعلام : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        در مسیر قنات<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "ganatScore", label: "قرار دارد", value: true },
                                { id: "ganatScore", label: "قرار ندارد", value: false },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        زمین لغزش<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "zaminScore", label: "بدون خطر", value: "بدون خطر" },
                                { id: "zaminScore", label: "خطر کم", value: "خطر کم" },
                                { id: "zaminScore", label: "خطر متوسط", value: "خطر متوسط" },
                                { id: "zaminScore", label: "خطر زیاد", value: "خطر زیاد" },
                                { id: "zaminScore", label: "خطر خیلی زیاد", value: "خطر خیلی زیاد" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        بافت فرسوده و ناپایدار<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "farsodeScore", label: "بافت عادی", value: "بافت عادی" },
                                { id: "farsodeScore", label: "بافت فرسوده", value: "بافت فرسوده" },
                                { id: "farsodeScore", label: "بافت ناپایدار", value: "بافت ناپایدار" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
                    <p style={{ fontWeight: "bold" }}>دسترسی پذیری : </p>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اینترنت ثابت مخابرات<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "mokhaberatScore", label: "خوب", value: "خوب" },
                                { id: "mokhaberatScore", label: "متوسط", value: "متوسط" },
                                { id: "mokhaberatScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اینترنت ثابت آسیاتک<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "asiatekScore", label: "خوب", value: "خوب" },
                                { id: "asiatekScore", label: "متوسط", value: "متوسط" },
                                { id: "asiatekScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        اینترنت ثابت پارس آنلاین<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "parsOnlineScore", label: "خوب", value: "خوب" },
                                { id: "parsOnlineScore", label: "متوسط", value: "متوسط" },
                                { id: "parsOnlineScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آنتن دهی ایرانسل<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "irancellScore", label: "خوب", value: "خوب" },
                                { id: "irancellScore", label: "متوسط", value: "متوسط" },
                                { id: "irancellScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آنتن دهی همراه اول<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "hamrahavalScore", label: "خوب", value: "خوب" },
                                { id: "hamrahavalScore", label: "متوسط", value: "متوسط" },
                                { id: "hamrahavalScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        آنتن دهی رایتل<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NormalUsers_SabteAgahiAreaSelectContain">
                        <Select
                            placeholder=""
                            styles={customStyles}
                            options={[
                                { id: "raightelScore", label: "خوب", value: "خوب" },
                                { id: "raightelScore", label: "متوسط", value: "متوسط" },
                                { id: "raightelScore", label: "ضعیف", value: "ضعیف" },
                            ]}
                            onChange={accessibilityHandleChange}
                        ></Select>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا مسجد ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadMasgedScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا مدرسه ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadMadreseScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا بیمارستان ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadBimarestanScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا مترو ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadMetroScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "1", gridColumnEnd: "2", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا هایپرمارکت ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadMarketScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "2", gridColumnEnd: "3", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا میوه وتره بار(متر)<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadMiveScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "3", gridColumnEnd: "4", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا اتوبان ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadOtobanScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div className="BaaHam_NU_SabteAgahiBottomGrid" style={{ gridColumnStart: "4", gridColumnEnd: "5", marginTop: "12px" }}>
                    <span className="BaaHam_NU_SabteAgahiBottomGridTitle">
                        فاصله تا پمپ بنزین ( متر )<span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="BaaHam_NU_SabteAgahiBottomGridInputForBack2">
                        <input className="BaaHam_NU_SabteAgahiBottomGridInput" type={"number"} id={"roadBenzinScore"} onChange={accessibilityHandleNumberInputChange}></input>
                    </div>
                </div>
                <div style={{ height: "4px", margin: "24px 0", gridColumnStart: "1", gridColumnEnd: "5", borderBottom: "solid 2px grey" }}></div>
                {/* /////////////////////////////////////////////////////////////////// */}
            </div>

            <div className="BaaHam_NormalUsers_SabteAgahiButton1" style={{ marginTop: "24px" }}>
                <span>ثبت دسترسی پذیری</span>
            </div>
        </div>
    );
}

export default BaaHam_VisitingExpertUser_ArzyabiForm;
